/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_State_UnknownInputs */

const en_inbox_state_unknown = /** @type {(inputs: Inbox_State_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unknown`)
};

const id_inbox_state_unknown = /** @type {(inputs: Inbox_State_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tidak diketahui`)
};

/**
* | output |
* | --- |
* | "unknown" |
*
* @param {Inbox_State_UnknownInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_state_unknown = /** @type {((inputs?: Inbox_State_UnknownInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_State_UnknownInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_state_unknown(inputs)
	return en_inbox_state_unknown(inputs)
});